import { render, staticRenderFns } from "./PurchaseQuotationTrendChart.vue?vue&type=template&id=ef0fee74"
import script from "./PurchaseQuotationTrendChart.vue?vue&type=script&lang=js"
export * from "./PurchaseQuotationTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports